<template>
  <UiSection id="club" class="flex flex-wrap justify-around">
    <div class="absolute inset-0 bg-gradient-to-b from-transparent to-black"></div>
    <div class="relative flex flex-col items-center p-2 w-full sm:w-1/2 md:w-1/3">
      <div class="border-2 border-gray-900 rounded h-16/9">
        <iframe src="https://vk.com/video_ext.php?oid=-169530082&id=456239139&hash=031cae25703763c7" width="100%" height="100%" allowfullscreen></iframe>
      </div>
    </div>
    <div class="relative flex flex-col items-center p-2 w-full sm:w-1/2 md:w-1/3">
      <a class="w-full rounded bg-black cursor-pointer" href="/static/colizeum_01.jpg" target="_blank">
        <img class="w-full border-2 border-gray-900 rounded opacity-75 hover:opacity-100" src="../../assets/colizeum/01_preview.jpg" alt />
      </a>
    </div>
    <div class="relative flex flex-col items-center p-2 w-full sm:w-1/2 md:w-1/3">
      <a class="w-full rounded bg-black cursor-pointer" href="/static/colizeum_02.jpg" target="_blank">
        <img class="w-full border-2 border-gray-900 rounded opacity-75 hover:opacity-100" src="../../assets/colizeum/02_preview.jpg" alt />
      </a>
    </div>
    <div class="relative flex flex-col items-center p-2 w-full sm:w-1/2 md:w-1/3">
      <a class="w-full rounded bg-black cursor-pointer" href="/static/colizeum_03.jpg" target="_blank">
        <img class="w-full border-2 border-gray-900 rounded opacity-75 hover:opacity-100" src="../../assets/colizeum/03_preview.jpg" alt />
      </a>
    </div>
    <div class="relative flex flex-col items-center p-2 w-full sm:w-1/2 md:w-1/3">
      <a class="w-full rounded bg-black cursor-pointer" href="/static/colizeum_04.jpg" target="_blank">
        <img class="w-full border-2 border-gray-900 rounded opacity-75 hover:opacity-100" src="../../assets/colizeum/04_preview.jpg" alt />
      </a>
    </div>
    <div class="relative flex flex-col items-center p-2 w-full sm:w-1/2 md:w-1/3">
      <a class="w-full rounded bg-black cursor-pointer" href="/static/colizeum_05.jpg" target="_blank">
        <img class="w-full border-2 border-gray-900 rounded opacity-75 hover:opacity-100" src="../../assets/colizeum/05_preview.jpg" alt />
      </a>
    </div>
  </UiSection>
</template>

<script>
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { menu } from '../../store.js'

  export default {
    name: 'SectionLocation',
    setup() {
      const { t } = useI18n({
        messages: {
          en: {
            header: 'Club',
          },
          ru: {
            header: 'Клуб',
          },
        },
      })

      menu.club = {
        name: computed(() => t('header')),
        icon: 'fa fa-map',
      }

      return { t }
    },
  }
</script>

<style scoped>
  section {
    padding-top: 30% !important;
    background: url('../../assets/colizeum/bg.jpg');
    background-size: cover;
  }
</style>
